import { Helmet } from "react-helmet-async";
import React from 'react';

const DefaultSEO = ({ 
    title, 
    description, 
    keywords,
    url, 
    ogTitle,
    ogDescription,
    ogImage,
    ogType = "website",
    schema,
    children
}) => {
    const defaultTitle = "ZoyoTrip - Book Hotels & Cars Easily";
    const defaultDesc = "Find and book affordable hotels and cars in India with ZoyoTrip. We offer the best deals and instant booking.";
    const defaultKeywords = "hotel booking, cars, ZoyoTrip, travel deals, online reservation, hotels in India";
    const defaultUrl = "https://www.zoyotrip.com";
    const defaultOgImage = "https://www.zoyotrip.com/og-image.jpg"; // Update this with a real image URL when available

    const finalTitle = title ? `${title} | ZoyoTrip` : defaultTitle;
    const finalDesc = description || defaultDesc;
    const finalUrl = url || defaultUrl;
    const finalOgImage = ogImage || defaultOgImage;

    // Organization Schema
    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ZoyoTrip",
        "url": "https://www.zoyotrip.com",
        "logo": "https://www.zoyotrip.com/logo.png",
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-9876543210", // Replace with real phone number
            "contactType": "Customer Service",
            "areaServed": "IN",
            "availableLanguage": "en"
        },
        "sameAs": [
            "https://www.facebook.com/zoyotrip",
            "https://www.twitter.com/zoyotrip",
            "https://www.instagram.com/zoyotrip"
        ]
    };

    return (
        <Helmet>
            {/* Standard SEO */}
            <title>{finalTitle}</title>
            <meta name="description" content={finalDesc} />
            <meta name="keywords" content={keywords || defaultKeywords} />
            <meta name="author" content="ZoyoTrip Team" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={finalUrl} />

            {/* Open Graph / Facebook / LinkedIn */}
            <meta property="og:type" content={ogType} />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:title" content={ogTitle || finalTitle} />
            <meta property="og:description" content={ogDescription || finalDesc} />
            <meta property="og:image" content={finalOgImage} />
            <meta property="og:site_name" content="ZoyoTrip" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={finalUrl} />
            <meta name="twitter:title" content={ogTitle || finalTitle} />
            <meta name="twitter:description" content={ogDescription || finalDesc} />
            <meta name="twitter:image" content={finalOgImage} />

            {/* Schemas */}
            <script type="application/ld+json">
                {JSON.stringify(organizationSchema)}
            </script>
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}

            {/* Any additional tags injected as children */}
            {children}
        </Helmet>
    );
};

export default DefaultSEO;
